/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAdobeXDIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-adobe-xd" */ './utils').then((m) => m.AdobeXDIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/adobe-xd/icon' },
);

const LazyAdobeXDSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-adobe-xd-search-result" */ './utils').then(
			(m) => m.AdobeXDSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/adobe-xd/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AdobeXDIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAdobeXDIconComponent />
	</Suspense>
);

export const AdobeXDSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAdobeXDSearchResultIconComponent />
	</Suspense>
);
